export const mediaTypeMap = {
    default: 0,
    center: 1,
    local: 2,
    vertical: 3
}

export const mediaTypeOptions = [
    { value: mediaTypeMap.default, label: '非分类' },
    { value: mediaTypeMap.center, label: '中央' }, 
    { value: mediaTypeMap.local, label: '本地' }, 
    { value: mediaTypeMap.vertical, label: '垂直' }
]